/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { rfqQuoteDetailsProposedDetailsGridItemStyles } from "@monsma/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGridItem";
import StickyNote from "@monsma/XDL/Icons/StickyNote";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridItemStyles.xRfqQuoteDetailsProposedDetailsGridItemStyles = {
    quantityHeadingAndText: sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.productPrice = {};

rfqQuoteDetailsProposedDetailsGridItemStyles.quotedPricingText = {
    weight: "bold",
    css: css`
        font-size: 10px;
        text-transform: uppercase;
        margin: 10px 0 5px 0;
    `,
};

rfqQuoteDetailsProposedDetailsGridItemStyles.toggleNotesLink = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
    `,
    icon: {
        iconProps: {
            src: StickyNote,
            size: 12,
            color: "common.ui5",
        },
        position: "left",
    },
};

rfqQuoteDetailsProposedDetailsGridItemStyles.quantityTextField = {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.formInputWrapper")}
            width: 65px;

            &&&& {
                margin: 0;
            }
        `,
        inputSelect: css`
            ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
            background: ${getColor("common.ui8")};
            font-size: 14px;
        `,
    },
    labelProps: {
        css: css`
            display: none;
        `,
    },
};
